const StarsBG = () => {
  return ( 
    <div id="starsBG">
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
    </div>
   );
}
 
export default StarsBG;